import React from "react";
import "./Footer.css";

function Footer() {
  return <footer className="footer">You may contact us: antvolkov84@gmail.com</footer>;
}

export default Footer;
